import { RouteRecordRaw } from 'vue-router'
import DocumentList from '@/pages/document/document-list/DocumentList.vue'
import DocumentReviewSingle from '@/pages/review/single/DocumentSingle.vue'
import Preview from '@/pages/review/single/tabs/Preview.vue'
import Resolutions from '@/pages/review/single/tabs/Resolutions.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/document-review',
    name: 'document-list-review',
    component: DocumentList,
    meta: {
      title: 'Мені на розгляд',
    },
  },
  {
    path: '/document-review/:uuid',
    name: 'document-review-single',
    component: DocumentReviewSingle,
    meta: {
      title: 'Документ',
      resource: 'documents',
      tabList: true,
    },
    redirect: { name: 'document-review-preview' },
    children: [
      {
        path: 'preview',
        name: 'document-review-preview',
        component: Preview,
        meta: {
          title: 'Документ',
        },
      },
      {
        path: 'resolutions',
        name: 'document-review-resolutions',
        component: Resolutions,
        meta: {
          title: 'Резолюції',
        },
      },
    ],
  },
]

export default routes
